import { get } from '../api.service';

export const fetchLoyaltyStatus = async () => {
    try {
        const response = await get('loyaltydashboard/status');
        return response;
    } catch (error) {
        console.error('Error fetching loyalty status:', error);
        throw error;
    }
};